export const announcementTypes = {
    //admin announcement types
    ADD_NEW_ANNOUNCEMENT_BY_ADMIN_START: 'ADD_NEW_ANNOUNCEMENT_BY_ADMIN_START',
    ADD_NEW_ANNOUNCEMENT_BY_ADMIN_SUCCESS:
        'ADD_NEW_ANNOUNCEMENT_BY_ADMIN_SUCCESS',
    ADD_NEW_ANNOUNCEMENT_BY_ADMIN_FAILED:
        'ADD_NEW_ANNOUNCEMENT_BY_ADMIN_FAILED',
    ADD_NEW_ANNOUNCEMENT_BY_ADMIN_END: 'ADD_NEW_ANNOUNCEMENT_BY_ADMIN_END',

    GET_ALL_ANNOUNCEMENT_BY_ADMIN_START: 'GET_ALL_ANNOUNCEMENT_BY_ADMIN_START',
    GET_ALL_ANNOUNCEMENT_BY_ADMIN_SUCCESS:
        'GET_ALL_ANNOUNCEMENT_BY_ADMIN_SUCCESS',
    GET_ALL_ANNOUNCEMENT_BY_ADMIN_FAILED:
        'GET_ALL_ANNOUNCEMENT_BY_ADMIN_FAILED',
    GET_ALL_ANNOUNCEMENT_BY_ADMIN_END: 'GET_ALL_ANNOUNCEMENT_BY_ADMIN_END',

    UPDATE_ANNOUNCEMENT_BY_ADMIN_START: 'UPDATE_ANNOUNCEMENT_BY_ADMIN_START',
    UPDATE_ANNOUNCEMENT_BY_ADMIN_SUCCESS:
        'UPDATE_ANNOUNCEMENT_BY_ADMIN_SUCCESS',
    UPDATE_ANNOUNCEMENT_BY_ADMIN_FAILED: 'UPDATE_ANNOUNCEMENT_BY_ADMIN_FAILED',
    UPDATE_ANNOUNCEMENT_BY_ADMIN_END: 'UPDATE_ANNOUNCEMENT_BY_ADMIN_END',

    DELETE_ANNOUNCEMENT_BY_ADMIN_START: 'DELETE_ANNOUNCEMENT_BY_ADMIN_START',
    DELETE_ANNOUNCEMENT_BY_ADMIN_SUCCESS:
        'DELETE_ANNOUNCEMENT_BY_ADMIN_SUCCESS',
    DELETE_ANNOUNCEMENT_BY_ADMIN_FAILED: 'DELETE_ANNOUNCEMENT_BY_ADMIN_FAILED',
    DELETE_ANNOUNCEMENT_BY_ADMIN_END: 'DELETE_ANNOUNCEMENT_BY_ADMIN_END',

    //-----------------------
    GET_AN_ANNOUNCEMENT_START: 'GET_AN_ANNOUNCEMENT_START',
    GET_AN_ANNOUNCEMENT_SUCCESS: 'GET_AN_ANNOUNCEMENT_SUCCESS',
    GET_AN_ANNOUNCEMENT_FAILED: 'GET_AN_ANNOUNCEMENT_FAILED',
    GET_AN_ANNOUNCEMENT_END: 'GET_AN_ANNOUNCEMENT_END',

    GET_ALL_ANNOUNCEMENT_START: 'GET_ALL_ANNOUNCEMENT_START',
    GET_ALL_ANNOUNCEMENT_SUCCESS: 'GET_ALL_ANNOUNCEMENT_SUCCESS',
    GET_ALL_ANNOUNCEMENT_FAILED: 'GET_ALL_ANNOUNCEMENT_FAILED',
    GET_ALL_ANNOUNCEMENT_END: 'GET_ALL_ANNOUNCEMENT_END',
}
